<template>
  <div>登录概况</div>
  <div class="s_flex_bian_c">
    <div class="m-r-20">
      <!-- <div ref="echartCircleDealer" style="width:50%;height:200px;display: inline-block;"></div> -->
      <a-progress type="circle" :percent="channel_visitor_data.dealer_proportion" :format="percent =>`经销商登录占比 ${percent}`" :width="200" style="margin-right:50px;font-size:12px" />
      <a-progress type="circle" :percent="channel_visitor_data.store_proportion" :format="percent =>`门店登录占比${percent}`" :width="200" />
      <!-- <div ref="echartCircleStore" style="width:50%;height:200px;display: inline-block;"></div> -->
    </div>
    <div class="flex_1">
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='list'>
      </a-table>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    list: Array,
    channel_visitor_data: Object,
  },
  setup() {
    let columns = [
      {
        title: "类型",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "总数",
        dataIndex: "count",
        key: "count",
      },
      {
        title: "登录人数",
        dataIndex: "loginTotal",
        key: "loginTotal",
      },
      {
        title: "占比",
        dataIndex: "proportion",
        key: "proportion",
      },
    ];
    return {
      columns,
    };
  },
};
</script>
<style lang="less" scoped>
/deep/.ant-progress-text{
  font-size: 14px;
}
</style>